/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneAuthorDetails from 'base/components/standalone/AuthorDetails';

export const DynamicStandaloneAuthorDetails = StandaloneAuthorDetails;
export type DynamicStandaloneAuthorDetailsProps = PropsFromComponent<typeof StandaloneAuthorDetails>;

export const DynamicStandaloneAuthorDetailsWith = (extras: DynamicStandaloneExtras): typeof StandaloneAuthorDetails => {
    return function DynamicStandaloneAuthorDetails(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'AuthorDetails');
        return <StandaloneAuthorDetails {...mergeProps({ options: { theme } }, props)} />;
    }
}